import { find, get } from "lodash";
import React, { Component } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import Modal from "~/components/common/molecules/Modal";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { partnerInfo } from "~/configs/partnerDetails";
import {
  changeFeeCode,
  clearDataSearchFeeCode,
  searchFeeByPatientCode,
  searchFeeCode
} from "~/store/fee/feeActions";
import { urlImgBillCode } from "~/utils/manageResource";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const FeeSearchPageDesktop = Loadable({
  loader: () => import("~/components/desktop/pages/FeeSearch"),
  loading: LoadableLoading
});

class FeeSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalViewImage: false
    };
  }

  methods = {
    handleGoBack: () => {
      const { history } = this.props;
      history.push("/");
    },
    toggleModalViewImage: () => {
      this.setState({
        modalViewImage: !this.state.modalViewImage
      });
    }
  };

  componentDidMount() {
    this.props.clearDataSearchFeeCode();
  }

  render() {
    const content = urlImgBillCode ? (
      <img src={urlImgBillCode} alt="" className="img-fluid" />
    ) : (
      "Chưa có hình ảnh minh họa."
    );

    return (
      <React.Fragment>
        <FeeSearchPageDesktop {...this.props} {...this.methods} />

        <Modal
          modal={this.state.modalViewImage}
          title="Xem cách tìm mã số thanh toán"
          toggle={this.methods.toggleModalViewImage}
          children={content}
          centered
          className="centered"
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    fee: { hosNumber, fee, loading }
  } = state;
  return {
    device: type,
    hosNumber,
    fee,
    loading
  };
};

const FeeSearchHelmet = withTitle({
  component: FeeSearch,
  title: `${hospitalName.value} | Thanh toán viện phí nội trú`
});

export default connect(mapStateToProps, {
  changeFeeCode,
  searchFeeCode,
  searchFeeByPatientCode,
  clearDataSearchFeeCode
})(FeeSearchHelmet);
